// extracted by mini-css-extract-plugin
export default {"layout":"SidebarHeaderLayout_layout__s7H+B"};